import React, { useState, useEffect, useContext } from 'react'
import * as R from 'ramda'
import styled from 'styled-components'

import { LayoutContext } from '../../contexts'
import useIsMountedRef from '../../hooks/useIsMountedRef'
import { useGlobal } from '../../hooks/useGlobal'
import ReviewStars from './ReviewStars'

const StyledReviewStars = styled.div`
  white-space: nowrap;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  transition: opacity 0.2s ease-in;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    cursor: pointer;
    align-items: center;
    margin-bottom: ${(props) => (props.productPage ? '1.3vw' : '0')};
  }
`

const ReviewsCopyBadge = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: ${(props) =>
    props.productPage ? '3vw' : props.theme.fontSize.m18};
  color: ${(props) => props.theme.colors.black};
  padding-left: ${(props) => props.theme.space.marginMobile * 0.1}vw;
  letter-spacing: 0.005em;
  margin-top: 0.25em;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
  }
`

const fetchReviews = async (skus, setCount, setStars, isMountedRef) => {
  const base =
    'https://api.trustpilot.com/v1/product-reviews/business-units/55bf22080000ff000581b7e9/'
  const apikey = 'yPwGMsdo8dG5IAcZ8hAZGy5o9VjXhFg0'
  const sku = skus?.join(',')

  const summaryUrl = new URL(base)
  summaryUrl.search = new URLSearchParams({ apikey, sku })

  const [summaryResponse] = await Promise.all([fetch(summaryUrl)])

  const [summaryData] = await Promise.all([summaryResponse.json()])

  if (isMountedRef.current) {
    setCount(summaryData.numberOfReviews.total)
    setStars(summaryData.starsAverage)
  }
}

const ReviewStarsProduct = ({ legacy_skus, className, productPage }) => {
  const isMountedRef = useIsMountedRef()
  const [stars, setStars] = useState(4)
  const [count, setCount] = useState(0)

  useEffect(() => {
    fetchReviews(legacy_skus, setCount, setStars, isMountedRef)
  }, [isMountedRef])
  const { node_locale } = useContext(LayoutContext)

  const {
    product: { reviews: reviewsText, review: reviewText },
  } = useGlobal(['product'], node_locale)

  return (
    <div className={className}>
      <StyledReviewStars visible={count !== 0} productPage={productPage}>
        <ReviewStars stars={stars} />
        <ReviewsCopyBadge
          productPage={productPage}
          className='reviews-copy-badge'
        >
          <div>{`${count} ${count < 2 ? reviewText : reviewsText}`}</div>
        </ReviewsCopyBadge>
      </StyledReviewStars>
    </div>
  )
}

export default ReviewStarsProduct
